module.exports = __webpack_public_path__ + "static/media/Poweredby_logo@2x.573ac48a.png";